"use client";

import type { DehydratedState } from "@tanstack/react-query";
import { HydrationBoundary as TanstackHydrationBoundary } from "@tanstack/react-query";
import type { ReactNode } from "react";

interface ClientHydrationBoundaryProps {
	state: DehydratedState;
	children: ReactNode;
}

/**
 * Client-side wrapper for HydrationBoundary.
 * This ensures HydrationBoundary is only used in client components
 * where QueryClient context is available.
 */
export function ClientHydrationBoundary({
	state,
	children,
}: ClientHydrationBoundaryProps) {
	return (
		<TanstackHydrationBoundary state={state}>
			{children}
		</TanstackHydrationBoundary>
	);
}
